<div class="modal-header" nfModalVariant="warning" hsDraggable="modal-dialog">
  <h4 class="modal-title">Uncommitted Changes Detected</h4>
  <button
    nf-icon-button
    icon="close"
    class="btn-bare"
    ngbTooltip="Close"
    (click)="activeModal.dismiss()"
  >
    Close
  </button>
</div>

<div class="modal-body" hsDraggable="modal-dialog">
  <h3>
    A run has finished for account {{ accountIds.join(', ') }} where you have
    {{ changes }} uncommitted changes.
  </h3>
  <h3>
    In order to ensure you are working with the most up to date version of the
    account's data, you will need to refresh your session.
  </h3>
  <div class="form-group option-content">
    <nf-form-control label="What would you like to do?">
      <nf-radio-group [formControl]="radioInline">
        <nf-radio-button
          class="option-content"
          label="Submit your changes and refresh your session"
          [value]="RUN_WITH_ETLS"
        ></nf-radio-button>
        <nf-radio-button
          class="option-content"
          label="Discard your changes and refresh your session"
          [value]="DISCARD"
        ></nf-radio-button>
        <nf-radio-button
          class="option-content"
          label="Keep your unsubmitted changes and do not refresh your session"
          [value]="KEEP"
        ></nf-radio-button>
      </nf-radio-group>
    </nf-form-control>
  </div>
</div>

<div class="modal-footer" hsDraggable="modal-dialog">
  <button nf-button="cancel" (click)="cancel()">Cancel</button>
  <button
    id="modal-submit-button"
    nf-button="primary"
    [disabled]="action == null"
    (click)="submit()"
    data-cy="continue-modal-button"
  >
    Apply
  </button>
</div>
